export const STATS = {
    INIT: '',
    PULLING: 'pulling',
    ENOUGH: 'pulling enough',
    REFRESHING: 'refreshing',
    REFRESHED: 'refreshed',
    RESET: 'reset',
    LOADING: 'loading'
};
export const TIPS = {
    [STATS.PULLING]: '下拉刷新',
    [STATS.ENOUGH]: '松开立即刷新',
    [STATS.REFRESHING]: '正在努力刷新...',
    [STATS.REFRESHED]: '刷新成功',
    [STATS.LOADING]: '正在努力加载...',
    NOMORE: '没有更多了~'
};
